import styled from 'styled-components';
import Link from '@mui/material/Link';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
export const Wrapper = styled.div({
    display: 'flex',
    height: 48,
});
export const CustomLink = styled(Link)({
    display: 'flex',
    alignItems: 'center',
    margin: '0 24px 0 0',
    padding: '0 24px 0 0',
    borderRight: `solid 1px ${Colors.grey200}`,
    '&:last-child': {
        borderRight: 0,
        margin: 0,
        padding: 0,
    },
});
export const CustomImage = styled.img({
    maxWidth: 124,
    minWidth: 0,
    maxHeight: 24,
    [`@media (min-width: ${breakpointLG})`]: {
        maxWidth: 180,
        maxHeight: 31,
    },
});
//# sourceMappingURL=styles.js.map